import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { DoeState } from './state';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import ErrorManager from '@/common/utils/ErrorManager';
import { DoeActions, DoeActionTypes } from '@/modules/DOE/store/action-types';
import { DOE } from '@/modules/DOE/store/mutation-types';
import DOEService, { FiltreDoe } from '@/modules/DOE/service/DOEService';

export const actions: ActionTree<DoeState, RootState> = {
    async [DoeActions.GET_DOE_PUBLIE]({ commit }: DoeActionTypes, payload: FiltreDoe) {
        commit(DOE.SET_IS_LOADING, true);
        try {
            const response = await DOEService.getDoePublies(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(DOE.SET_ITEM, response.data.content);
                    commit(DOE.SET_SCROLL, 0);
                    commit(DOE.SET_NB_OF_PAGES, response.data.totalPages);
                    commit(DOE.SET_NB_ITEMS, response.data.totalElements);
                } else {
                    commit(DOE.ADD_ITEMS, response.data.content);
                }
            }
            commit(DOE.SET_IS_LOADING, false);
        } catch (error) {
            commit(DOE.SET_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },

    async [DoeActions.GET_PDF_DOE]({ commit }: DoeActionTypes, payload) {
        commit(DOE.SET_PDF_IS_LOADING, true);
        try {
            const response = await DOEService.getPdfDoe(payload.idMasque);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data], { type: 'application/zip' });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.target = 'blank';

                link.download = payload.libelle;

                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(DOE.SET_PDF_IS_LOADING, false);
        } catch (error) {
            commit(DOE.SET_PDF_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
